const Dashboard = () => import('@/views/dashboard/Dashboard.vue');
const SuccessPageRecog = () => import('@/components/successPageRecog/SuccessPage.vue');
const EditPageRecog = () => import('@/components/editPageRecog/EditPage.vue');
const FailPage = () => import('@/components/failPage/FailPage.vue');
const Artificial = () => import('@/components/artificial/Artificial.vue');
const Docs = () => import('@/components/docsIdentify/Docs.vue');
const DocsIndex = () => import('@/components/docsIdentify/DocsIndex.vue');
const DefDocsIndex = () => import('@/components/docsIdentify/DefDocsIndex.vue');
const ExportFile = () => import('@/components/exportFile/exportFile.vue');

const Verify = () => import('@/components/verify/verify.vue');
const History = () => import('@/components/history/history.vue');
const Alter = () => import('@/components/history/alter.vue');

const EditPage = () => import('@/components/editPage/EditPage.vue');
const TestPage = () => import('@/components/testPage/TestPage.vue');
const ErrorPage = () => import('@/components/testPage/ErrorPage.vue');

const TemDocs = () => import('@/components/template/Docs.vue');
const TemDocsIndex = () => import('@/components/template/DocsIndex.vue');

const DataSet = () => import('@/components/dataset/DataSet.vue');
const DatasetIndex = () => import('@/components/dataset/DatasetIndex.vue');
const DatasetUpdate = () => import('@/components/dataset/DatasetUpdate.vue');
const SuccessPage = () => import('@/components/successPage/SuccessPage.vue');

const Classifyindex = () => import('@/components/classify/index.vue');
const ClassifyEdit = () => import('@/components/classify/editPage/EditPage.vue');
const ClassifyEditError = () => import('@/components/classify/editPage/EditPageErrorvue.vue');

const FieldIndex = () => import('@/components/field/index.vue');

import payment_success from '@/views/userhome/paymentSuccess.vue'

export const login = {
  path: '/',
  redirect: '/home'
};

export const success = {
  path: '/payment_success/:is',
  component: payment_success,
};
// path: 'userHome',
//     title: '用户中心',
//     name: 'userHome',
//     component: () =>
//     import('@/views/userhome/index.vue'),
//     meta: {
//   keepAlive: false, //此组件不需要被缓存
//       type: 'endoc'
// }

export const homeRouter = {
  path: '/home',
  name: 'home',
  meta: {
    title: '二郎神'
  },
  component: () =>
    import('@/views/home/index.vue'),
  children: [{
    path: '',
    title: '产品功能',
    name: 'home-product',
    component: () =>
      import('@/views/home/product.vue')
  }, {
    path: '/free',
    title: '免费试用',
    name: 'home-free',
    component: () =>
      import('@/views/home/free.vue')
  }, {
    path: '/solution',
    title: '解决方案',
    name: 'home-solution',
    component: () =>
      import('@/views/home/solution.vue')
  }, {
    path: '/goodsList',
    title: '套餐推荐',
    name: 'goodsList',
    component: () =>
      import('@/views/home/goodsList.vue')
  }]
};

export const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录'
  },
  component: () =>
    import('@/views/login/Login.vue')
};
export const Yhxieyi = {
  path: '/Yhxieyi',
  name: 'Yhxieyi',
  // redirect:'/Yhxieyi',
  meta: {
    title: 'Login - 用户服务协议'
  },
  component: () =>
    import('@/views/xieyi/Yhxieyi.vue')
};
export const Yszhengce = {
  path: '/Yszhengce',
  name: 'Yszhengce',
  // redirect:'/Yszhengce',
  meta: {
    title: 'Login - 用户隐私政策'
  },
  component: () =>
    import('@/views/xieyi/Yszhengce.vue')
};


export const index = {
  path: '/dashboard',
  meta: {
    title: 'Index'
  },
  name: 'Dashboard',
  component: Dashboard,
  children: [{
    path: 'endoc',
    title: '英文单证识别',
    name: 'endoc',
    component: Docs,
    redirect: '/dashboard/endoc/index',
    meta: {
      keepAlive: false, //此组件需要被缓存
    },
    children: [{
      path: 'index',
      title: '英文单证识别-首页',
      name: 'endoc-docsindex',
      component: DocsIndex,
      meta: {
        keepAlive: true, //此组件需要被缓存
        type: 'endoc'
      }
    },
    {
      path: 'successPageRecog',
      title: '单证识别-成功查看结果',
      name: 'endoc-successpage',
      component: SuccessPageRecog,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'endoc'
      }
    },
    {
      path: 'failpage',
      title: '单证识别-失败查看结果',
      name: 'endoc-failpage',
      component: FailPage,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'endoc'
      }
    },
    {
      path: 'editPageRecog',
      title: '单证识别-编辑查看结果',
      name: 'endoc-editpage',
      component: EditPageRecog,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'endoc'
      }
    },
    {
      path: 'artificial',
      title: '人工处理',
      name: 'endoc-artificial',
      component: Artificial,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'endoc'
      }
    },
      // {
      //     path: 'history',
      //     title: '单证校验历史',
      //     name: 'endoc-history',
      //     component: History,
      //     meta: {
      //         keepAlive: false, //此组件不需要被缓存
      //     }
      // }

    ]
  },
  {
    path: 'cedoc',
    title: '中英文单证识别',
    name: 'cedoc',
    component: Docs,
    redirect: '/dashboard/cedoc/index',
    meta: {
      keepAlive: false, //此组件需要被缓存
    },
    children: [{
      path: 'index',
      title: '单证识别-首页',
      name: 'cedoc-docsindex',
      component: DocsIndex,
      meta: {
        keepAlive: true, //此组件需要被缓存
        type: 'cedoc'
      }
    },
    {
      path: 'successPageRecog',
      title: '单证识别-成功查看结果',
      name: 'cedoc-successpage',
      component: SuccessPageRecog,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'cedoc'
      }
    },
    {
      path: 'failpage',
      title: '单证识别-失败查看结果',
      name: 'cedoc-failpage',
      component: FailPage,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'cedoc'
      }
    },
    {
      path: 'editPageRecog',
      title: '单证识别-编辑查看结果',
      name: 'cedoc-editpage',
      component: EditPageRecog,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'cedoc'
      }
    },
    {
      path: 'artificial',
      title: '人工处理',
      name: 'cedoc-artificial',
      component: Artificial,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'cedoc'
      }
    },
      // {
      //     path: 'history',
      //     title: '单证校验历史',
      //     name: 'cedoc-history',
      //     component: History,
      //     meta: {
      //         keepAlive: false, //此组件不需要被缓存
      //         type: 'cedoc'
      //     }
      // },
    ]
  },
  {
    path: 'defdoc',
    title: '自定义单证识别',
    name: 'defdoc',
    component: Docs,
    redirect: '/dashboard/defdoc/index',
    meta: {
      keepAlive: false, //此组件需要被缓存
    },
    children: [{
      path: 'index',
      title: '自定义识别-首页',
      name: 'defdoc-docsindex',
      component: DefDocsIndex,
      meta: {
        keepAlive: true, //此组件需要被缓存
        type: 'cedoc'
      }
    },
    {
      path: 'successPageRecog',
      title: '单证识别-成功查看结果',
      name: 'defdoc-successpage',
      component: SuccessPageRecog,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'cedoc'
      }
    },
    // {
    //     path: 'history',
    //     title: '单证校验历史',
    //     name: 'gedoc-history',
    //     component: History,
    //     meta: {
    //         keepAlive: false, //此组件不需要被缓存
    //         type: 'gedoc'
    //     }
    // },
    {
      path: 'failpage',
      title: '单证识别-失败查看结果',
      name: 'defdoc-failpage',
      component: FailPage,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'gedoc'
      }
    },
    {
      path: 'editPageRecog',
      title: '单证识别-编辑查看结果',
      name: 'defdoc-editpage',
      component: EditPageRecog,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        type: 'cedoc'
      }
    },
      // {
      //     path: 'artificial',
      //     title: '人工处理',
      //     name: 'gedoc-artificial',
      //     component: Artificial,
      //     meta: {
      //         keepAlive: false, //此组件不需要被缓存
      //         type: 'gedoc'
      //     }
      // }
    ]
  },
  {
    path: 'template',
    title: '模板管理',
    name: 'template',
    component: TemDocs,
    redirect: '/dashboard/template/index',
    meta: {
      keepAlive: false, //此组件需要被缓存
    },
    children: [{
      path: 'index',
      title: '模板管理-首页',
      name: 'docsindex',
      component: TemDocsIndex,
      meta: {
        keepAlive: false, //此组件需要被缓存
      }
    },
    {
      path: 'editpage',
      title: '模板管理-编辑模板查看结果',
      name: 'editpage',
      component: EditPage,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    {
      path: 'testpage',
      title: '模板管理-测试模板查看结果',
      name: 'testpage',
      component: TestPage,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      },
    },
    {
      path: 'erroreage',
      title: '模板管理-测试模板查看结果-识别结果纠错',
      name: 'erroreage',
      component: ErrorPage,
      meta: {
        keepAlive: false, //此组件需要被缓存
      }
    }
    ]
  },
  {
    path: 'dataset',
    title: '标准数据集',
    name: 'dataset',
    component: DataSet,
    redirect: '/dashboard/dataset/index',
    meta: {
      keepAlive: false, //此组件需要被缓存
    },
    children: [{
      path: 'index',
      title: '标准数据集-首页',
      name: 'datasetindex',
      component: DatasetIndex,
      meta: {
        keepAlive: false, //此组件需要被缓存
      }
    }, {
      path: 'update',
      title: '标准数据集-更新数据集',
      name: 'datasetupdate',
      component: DatasetUpdate,
      meta: {
        keepAlive: false, //此组件需要被缓存
      }
    }]
  }, {
    path: 'classify',
    title: '单证分类管理',
    name: 'classify',
    component: TemDocs,
    redirect: '/dashboard/classify/index',
    meta: {
      keepAlive: false, //此组件需要被缓存
    },
    children: [{
      path: 'index',
      title: '单证分类管理-首页',
      name: 'classify',
      component: Classifyindex,
      meta: {
        keepAlive: false, //此组件需要被缓存
      }
    }, {
      path: 'edit',
      title: '模板管理-编辑模板查看结果',
      name: 'classifyEdit',
      component: ClassifyEdit,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    }, {
      path: 'editPageErrorvue',
      title: '模板管理-编辑模板查看结果-识别结果纠错',
      name: 'classifyEditError',
      component: ClassifyEditError,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    ]
  }, {
    path: 'field',
    title: '字段管理',
    name: 'field',
    component: TemDocs,
    redirect: '/dashboard/field/index',
    meta: {
      keepAlive: false, //此组件需要被缓存
    },
    children: [{
      path: 'index',
      title: '字段管理-首页',
      name: 'field',
      component: FieldIndex,
      meta: {
        keepAlive: false, //此组件需要被缓存
      }
    }]
  }, {
    path: 'templateCommunity',
    title: '模板社区',
    name: 'templateCommunity',
    component: () =>
      import('@/views/template/index.vue'),
    meta: {
      keepAlive: false, //此组件不需要被缓存
      type: 'endoc'
    }
  }, {
    path: 'model',
    title: '专用模型',
    name: 'model',
    component: () =>
      import('@/views/model/index.vue'),
    meta: {
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: 'api',
    title: '接口文档',
    name: 'api',
    component: () =>
      import('@/views/api/index.vue'),
    meta: {
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: 'largeModle',
    title: '大模型识别',
    name: 'largeModle',
    component: () =>
      import('@/views/largeModle/index.vue'),
    meta: {
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: 'templateDetail',
    title: '模板管理-测试模板查看结果',
    name: 'testpage',
    component: () => import('@/views/template/TestPage.vue'),
    // component: TestPage,
    meta: {
      keepAlive: false, //此组件不需要被缓存
    },
  },
  {
    path: 'userHome',
    title: '用户中心',
    name: 'userHome',
    component: () =>
      import('@/views/userhome/index.vue'),
    meta: {
      keepAlive: false, //此组件不需要被缓存
      type: 'endoc'
    },
    children: [{
      path: '',
      title: '基础信息',
      name: 'baseInfo',
      component: () =>
        import('@/views/userhome/baseInfo.vue')
    }, {
      path: 'accountVIP',
      title: '账号VIP',
      name: 'accountVIP',
      component: () =>
        import('@/views/userhome/uservip.vue')
    }, {
      path: 'userList',
      title: '用户管理',
      name: 'userList',
      component: () =>
        import('@/views/userhome/userList.vue')
    }, {
      path: 'goodsInfo',
      title: '套餐推荐',
      name: 'goodsInfo',
      component: () =>
        import('@/views/userhome/goods.vue')
    }, {
      path: 'rechargeOrder',
      title: '充值订单',
      name: 'rechargeOrder',
      component: () =>
        import('@/views/userhome/rechargeOrder.vue')
    }, {
      path: 'report',
      title: '账单报表',
      name: 'report',
      component: () =>
        import('@/views/userhome/report.vue')
    }, {
      path: 'invoice',
      title: '我的发票',
      name: 'invoice',
      component: () =>
        import('@/views/userhome/invoice.vue')
    }, {
      path: 'deriveAllocation',
      title: '导出配置',
      name: 'deriveAllocation',
      component: () =>
        import('@/views/userhome/deriveAllocation.vue')
    }]
  },
  {
    path: 'successpage',
    title: '查看-标准数据集',
    name: 'successpage',
    component: SuccessPage,
    meta: {
      keepAlive: false, //此组件需要被缓存
    }
  },
  {
    path: 'exportFile',
    title: '导出文件',
    name: 'exportFile',
    component: ExportFile,
    meta: {
      keepAlive: false, //此组件不需要被缓存
    }
  }
    // {
    //     path: 'verify',
    //     title: '单证校验',
    //     name: 'verifypage',
    //     component: Verify,
    //     meta: {
    //         keepAlive: false, //此组件不需要被缓存
    //     }
    // }, {
    //     path: 'alter',
    //     title: '更换单证',
    //     name: 'alter',
    //     component: Alter,
    //     meta: {
    //         keepAlive: false, //此组件不需要被缓存
    //     }
    // },

  ]
};

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  login,
  loginRouter,
  index,
  Yhxieyi,
  Yszhengce,
  homeRouter,
  success
];
